var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-add-wrapper" },
    [
      _c(
        "b-row",
        { staticClass: "invoice-add" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", xl: "9", md: "8" } },
            [
              _c(
                "validation-observer",
                { ref: "proforma" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "invoice-preview-card",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "div",
                                { staticClass: "row align-items-center mb-2" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-1" },
                                    [_c("Logo")],
                                    1
                                  ),
                                  _c("div", { staticClass: "col-9" }, [
                                    _c("div", {}, [_c("CompanyName")], 1),
                                    _c("div", {}, [_c("Address")], 1),
                                  ]),
                                ]
                              ),
                              _c("hr", { staticClass: "invoice-spacing" }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between flex-md-row flex-column mt-0",
                                },
                                [
                                  _c("div", { staticClass: "pt-0" }, [
                                    _c(
                                      "div",
                                      { staticClass: "invoice-spacing" },
                                      [
                                        _c("h6", { staticClass: "mb-2" }, [
                                          _vm._v("Customer"),
                                        ]),
                                        _c("ClientAddress", {
                                          attrs: { client: _vm.whenSelected },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "invoice-number-date mt-md-0 mt-2",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-between mb-1",
                                        },
                                        [
                                          _c(
                                            "h4",
                                            { staticClass: "invoice-title" },
                                            [_vm._v("Proforma")]
                                          ),
                                          _c(
                                            "b-input-group",
                                            {
                                              staticClass:
                                                "input-group-merge invoice-edit-input-group disabled",
                                            },
                                            [
                                              _c(
                                                "b-input-group-prepend",
                                                {
                                                  staticClass:
                                                    "invoice-edit-input",
                                                  attrs: { "is-text": "" },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: { icon: "HashIcon" },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("b-form-input", {
                                                staticClass:
                                                  "invoice-edit-input",
                                                attrs: {
                                                  id: "invoice-data-id",
                                                  disabled: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.salesorderId
                                                      .orderNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.salesorderId,
                                                      "orderNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "salesorderId.orderNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-between mb-1",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v(" Issued Date: "),
                                          ]),
                                          _c("flat-pickr", {
                                            staticClass:
                                              "form-control invoice-edit-input",
                                            attrs: {
                                              config: {
                                                minDate: _vm.issuedDate,
                                              },
                                            },
                                            model: {
                                              value: _vm.issuedDate,
                                              callback: function ($$v) {
                                                _vm.issuedDate = $$v
                                              },
                                              expression: "issuedDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-between",
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              rules: "required",
                                              name: "Due Date",
                                              vid: "Due Date",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Due Date: "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c("flat-pickr", {
                                                              staticClass:
                                                                "form-control invoice-edit-input",
                                                              attrs: {
                                                                config: {
                                                                  minDate:
                                                                    _vm.issuedDate,
                                                                },
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.dueDate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.dueDate =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "dueDate",
                                                              },
                                                            }),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-between mt-2",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v("Currency:"),
                                          ]),
                                          _c("b-form-input", {
                                            staticClass: "invoice-edit-input",
                                            attrs: {
                                              id: "invoice-data-id",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.salesorderId.currency,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.salesorderId,
                                                  "currency",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "salesorderId.currency",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-md-between mt-2",
                                        },
                                        [
                                          _c("span", { staticClass: "title" }, [
                                            _vm._v("Exchange Rate:"),
                                          ]),
                                          _c("b-form-input", {
                                            staticClass: "invoice-edit-input",
                                            attrs: {
                                              id: "invoice-data-id",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.salesorderId.rate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.salesorderId,
                                                  "rate",
                                                  $$v
                                                )
                                              },
                                              expression: "salesorderId.rate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding" },
                            [
                              _c(
                                "div",
                                {
                                  ref: "form",
                                  staticClass: "repeater-form",
                                  style: { height: _vm.trHeight },
                                },
                                _vm._l(
                                  _vm.invoiceData.items,
                                  function (item, index) {
                                    return _c(
                                      "b-row",
                                      {
                                        key: index,
                                        ref: "row",
                                        refInFor: true,
                                        staticClass: "pb-2",
                                      },
                                      [
                                        _c("b-col", { attrs: { cols: "12" } }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex border rounded",
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticClass:
                                                        "flex-grow-1 px-2 pt-2",
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "6",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "static-label",
                                                            },
                                                            [_vm._v("Items")]
                                                          ),
                                                          _vm.optionsProduct
                                                            .length === 0
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex justify-content-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-spinner",
                                                                    {
                                                                      attrs: {
                                                                        variant:
                                                                          "primary",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "flex-grow-1 mr-1",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                "required",
                                                                              name: "Item",
                                                                              vid:
                                                                                "Item_" +
                                                                                index,
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "v-select",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-2 item-selector-title",
                                                                                          attrs:
                                                                                            {
                                                                                              options:
                                                                                                _vm.optionsProduct,
                                                                                              label:
                                                                                                "itemTitle",
                                                                                              clearable: false,
                                                                                              placeholder:
                                                                                                "Select Item",
                                                                                            },
                                                                                          on: {
                                                                                            input:
                                                                                              function (
                                                                                                val
                                                                                              ) {
                                                                                                return _vm.updateItemForm(
                                                                                                  index,
                                                                                                  val
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          scopedSlots:
                                                                                            _vm._u(
                                                                                              [
                                                                                                {
                                                                                                  key: "option",
                                                                                                  fn: function (
                                                                                                    ref
                                                                                                  ) {
                                                                                                    var itemTitle =
                                                                                                      ref.itemTitle
                                                                                                    var categoryName =
                                                                                                      ref.categoryName
                                                                                                    var subCategoryName =
                                                                                                      ref.subCategoryName
                                                                                                    return [
                                                                                                      _c(
                                                                                                        "div",
                                                                                                        {
                                                                                                          staticStyle:
                                                                                                            {
                                                                                                              display:
                                                                                                                "flex",
                                                                                                              "flex-direction":
                                                                                                                "column",
                                                                                                            },
                                                                                                        },
                                                                                                        [
                                                                                                          _c(
                                                                                                            "span",
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                _vm._s(
                                                                                                                  itemTitle
                                                                                                                )
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                          _c(
                                                                                                            "span",
                                                                                                            [
                                                                                                              _vm._v(
                                                                                                                _vm._s(
                                                                                                                  categoryName ||
                                                                                                                    "-"
                                                                                                                ) +
                                                                                                                  " : " +
                                                                                                                  _vm._s(
                                                                                                                    subCategoryName ||
                                                                                                                      "-"
                                                                                                                  )
                                                                                                              ),
                                                                                                            ]
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  },
                                                                                                },
                                                                                              ],
                                                                                              null,
                                                                                              true
                                                                                            ),
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.id,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "id",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.id",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      errors.length
                                                                                        ? _c(
                                                                                            "small",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-danger",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  errors[0]
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "static-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Unit Price (" +
                                                                  _vm._s(
                                                                    _vm.currencySymbol
                                                                  ) +
                                                                  ")*"
                                                              ),
                                                            ]
                                                          ),
                                                          _c("b-form-input", {
                                                            staticClass: "mb-2",
                                                            attrs: {
                                                              type: "number",
                                                            },
                                                            on: {
                                                              keypress:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.allowOnlyNumbers(
                                                                    $event
                                                                  )
                                                                },
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.sanitizeInput(
                                                                  "cost"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value: item.cost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "cost",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.cost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.vat
                                                        ? _c(
                                                            "b-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                lg: "2",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "label",
                                                                {
                                                                  staticClass:
                                                                    "static-label",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " VAT (%)"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  staticClass:
                                                                    "mb-2",
                                                                  attrs: {
                                                                    type: "number",
                                                                  },
                                                                  on: {
                                                                    keypress:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.allowOnlyNumbers(
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.tax,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "tax",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.tax",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "2",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-between",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                },
                                                                [
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "static-label",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Qty*"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "validation-provider",
                                                                    {
                                                                      attrs: {
                                                                        rules:
                                                                          "required|min_value:0.00001",
                                                                        name: "Quantity",
                                                                        vid:
                                                                          "Quantity_" +
                                                                          index,
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var errors =
                                                                                  ref.errors
                                                                                return [
                                                                                  _c(
                                                                                    "b-form-input",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-2",
                                                                                      attrs:
                                                                                        {
                                                                                          type: "number",
                                                                                        },
                                                                                      on: {
                                                                                        keypress:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.allowOnlyNumbers(
                                                                                              $event
                                                                                            )
                                                                                          },
                                                                                        input:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.sanitizeInput(
                                                                                              "qty"
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            item.qty,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                item,
                                                                                                "qty",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "item.qty",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  errors.length
                                                                                    ? _c(
                                                                                        "small",
                                                                                        {
                                                                                          staticClass:
                                                                                            "text-danger",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              errors[0]
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mb-1",
                                                            },
                                                            [
                                                              _c(
                                                                "b-button",
                                                                {
                                                                  attrs: {
                                                                    variant:
                                                                      "danger",
                                                                    size: "sm",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeItem(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Remove "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            lg: "12",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline d-lg-none",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Description"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "b-form-textarea",
                                                            {
                                                              staticClass:
                                                                "mb-2 mb-lg-0",
                                                              model: {
                                                                value:
                                                                  item.description,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "description",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "item.description",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("b-row", {
                                                    staticClass:
                                                      "flex-grow-1 p-2",
                                                  }),
                                                  _c("hr"),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "ripple",
                                      rawName: "v-ripple.400",
                                      value: "rgba(255, 255, 255, 0.15)",
                                      expression: "'rgba(255, 255, 255, 0.15)'",
                                      modifiers: { 400: true },
                                    },
                                  ],
                                  attrs: { size: "sm", variant: "primary" },
                                  on: { click: _vm.addNewItemInItemForm },
                                },
                                [_vm._v(" Add Item ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pb-0" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-0 mt-3 d-flex align-items-center",
                                      attrs: {
                                        cols: "12",
                                        md: "4",
                                        order: "2",
                                        "order-md": "1",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "h-100" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-nowrap mr-50",
                                                  attrs: {
                                                    for: "invoice-data-sales-person",
                                                  },
                                                },
                                                [_vm._v("Sales Person:")]
                                              ),
                                              _c("validation-provider", {
                                                attrs: {
                                                  rules: "required",
                                                  name: "Sales Person",
                                                  vid: "Sales Person",
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var errors = ref.errors
                                                      return [
                                                        _c("v-select", {
                                                          attrs: {
                                                            options:
                                                              _vm.optionsSalesPerson,
                                                            label: "text",
                                                            reduce: function (
                                                              option
                                                            ) {
                                                              return option.value
                                                            },
                                                            clearable: false,
                                                            searchable: true,
                                                            placeholder:
                                                              "Select Sales Person",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "option",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var text =
                                                                    ref.text
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "b-tooltip",
                                                                              rawName:
                                                                                "v-b-tooltip.hover",
                                                                              modifiers:
                                                                                {
                                                                                  hover: true,
                                                                                },
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "customer-option",
                                                                        attrs: {
                                                                          title:
                                                                            text,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              text
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "selected-option",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var text =
                                                                    ref.text
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        directives:
                                                                          [
                                                                            {
                                                                              name: "b-tooltip",
                                                                              rawName:
                                                                                "v-b-tooltip.hover",
                                                                              modifiers:
                                                                                {
                                                                                  hover: true,
                                                                                },
                                                                            },
                                                                          ],
                                                                        staticClass:
                                                                          "selected-customer",
                                                                        attrs: {
                                                                          title:
                                                                            text,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              text
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm.salesPersonId,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.salesPersonId =
                                                                $$v
                                                            },
                                                            expression:
                                                              "salesPersonId",
                                                          },
                                                        }),
                                                        errors.length
                                                          ? _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ]),
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "box-1" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-nowrap mr-50",
                                                      attrs: {
                                                        for: "invoice-data-sales-person",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Choose Warehouse:"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules: "required",
                                                      name: "Warehouse",
                                                      vid: "Warehouse",
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("v-select", {
                                                              attrs: {
                                                                id: "warehouse",
                                                                options:
                                                                  _vm.optionsWarehouse,
                                                                label: "text",
                                                                reduce:
                                                                  function (
                                                                    option
                                                                  ) {
                                                                    return option.value
                                                                  },
                                                                clearable: false,
                                                                searchable: true,
                                                                placeholder:
                                                                  "Select Warehouse",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "option",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var text =
                                                                          ref.text
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers:
                                                                                      {
                                                                                        hover: true,
                                                                                      },
                                                                                  },
                                                                                ],
                                                                              staticClass:
                                                                                "warehouse-option",
                                                                              attrs:
                                                                                {
                                                                                  title:
                                                                                    text,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                    {
                                                                      key: "selected-option",
                                                                      fn: function (
                                                                        ref
                                                                      ) {
                                                                        var text =
                                                                          ref.text
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              directives:
                                                                                [
                                                                                  {
                                                                                    name: "b-tooltip",
                                                                                    rawName:
                                                                                      "v-b-tooltip.hover",
                                                                                    modifiers:
                                                                                      {
                                                                                        hover: true,
                                                                                      },
                                                                                  },
                                                                                ],
                                                                              staticClass:
                                                                                "selected-warehouse",
                                                                              attrs:
                                                                                {
                                                                                  title:
                                                                                    text,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                              model: {
                                                                value:
                                                                  _vm.warehouseId,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.warehouseId =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "warehouseId",
                                                              },
                                                            }),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "mt-md-6 d-flex justify-content-end",
                                      attrs: {
                                        cols: "12",
                                        md: "8",
                                        order: "1",
                                        "order-md": "2",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "invoice-total-wrapper",
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center",
                                                },
                                                [_vm._v(" Discount Rate: ")]
                                              ),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("validation-provider", {
                                                    attrs: {
                                                      rules:
                                                        "min_value:0|max_value:" +
                                                        _vm.maxDiscountValue,
                                                      name: "Discount",
                                                      vid:
                                                        "Discount_" + _vm.index,
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function (ref) {
                                                          var errors =
                                                            ref.errors
                                                          return [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                id: "invoice-discount-value",
                                                                type: "number",
                                                                placeholder:
                                                                  _vm.discountPlaceholder,
                                                              },
                                                              on: {
                                                                blur: _vm.ensureMainDiscountNotNull,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.MainDiscount,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.MainDiscount =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "MainDiscount",
                                                              },
                                                            }),
                                                            errors.length
                                                              ? _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Discount:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.discountTotal.toFixed(
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Subtotal:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.subTotal.toFixed(2)
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm.vat
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "invoice-total-item",
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "invoice-total-title",
                                                    },
                                                    [_vm._v("VAT:")]
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "invoice-total-amount",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.currencySymbol
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.VATtotal.toFixed(
                                                              2
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c("hr", { staticClass: "my-50" }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "invoice-total-item",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-title",
                                                },
                                                [_vm._v("Total:")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "invoice-total-amount",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.currencySymbol
                                                      ) +
                                                      _vm._s(_vm.finalTotal) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("hr", { staticClass: "invoice-spacing" }),
                          _c(
                            "b-card-body",
                            { staticClass: "invoice-padding pt-0" },
                            [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Note: "),
                              ]),
                              _c("b-form-textarea", {
                                model: {
                                  value: _vm.note,
                                  callback: function ($$v) {
                                    _vm.note = $$v
                                  },
                                  expression: "note",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "invoice-actions mt-md-0 mt-2",
              attrs: { cols: "12", md: "4", xl: "3" },
            },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(113, 102, 240, 0.15)",
                          expression: "'rgba(113, 102, 240, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "mb-1",
                      attrs: { variant: "outline-primary", block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.handleDocBtn(_vm.id)
                        },
                      },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Documents "),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "3" },
                    },
                    [
                      _c(
                        "b-modal",
                        {
                          ref: "modal-view-proforma-document",
                          attrs: {
                            id: "modal-view-proforma-document",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View Proforma Documents",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("DocumentUpload", {
                            attrs: { documentDetails: this.documentDetails },
                            on: {
                              deleteFile: _vm.deleteFile,
                              downloadFile: _vm.downloadFile,
                              uploadFiles: _vm.uploadFiles,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(113, 102, 240, 0.15)",
                          expression: "'rgba(113, 102, 240, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      attrs: { variant: "outline-primary", block: "" },
                      on: {
                        click: function ($event) {
                          return _vm.updateSalesOrder()
                        },
                      },
                    },
                    [
                      _vm.loading
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v(" Save "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }